
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M61 0h6.1c15.8.9 31.3 7.6 42.4 19 10.1 10.2 16.6 23.8 18.1 38 1.5 13.7-1.5 27.8-8.6 39.7-7.4 12.5-19.1 22.3-32.7 27.3-14.1 5.3-30 5.3-44.1.2-14.2-5.1-26.5-15.5-33.9-28.8-7-12.1-9.6-26.6-7.7-40.5C2.8 39 11.4 24.1 24 14 34.4 5.6 47.6.7 61 0zm-4.2 10.4c-17.1 2.1-32.7 13.1-40.7 28.4-6.4 12-7.9 26.4-4.3 39.4 3.6 13.2 12.4 24.9 24.1 32 10.9 6.7 24.2 9.2 36.8 7.1C88 115 101.9 105.6 110 92.5c6.7-10.8 9.4-23.9 7.5-36.5-2-14-9.9-27-21.2-35.3-11.2-8.5-25.7-12.2-39.5-10.3zM29.7 59.1h19.6v9.8H29.7v29.6h32v-9.9H39.6v-9.9h19.6V49.2H39.6v-9.8h22.1v-9.9h-32v29.6zm36.9-29.5v9.8h22.1v9.9H69.1v29.6h19.6v9.8H66.6v9.9h31.9V69.1H78.9v-9.9h19.6V29.7c-10.6-.1-21.3-.1-31.9-.1z"}})])
          )
        }
      }
    